import React, { useEffect, useState } from "react";
import styled from "@emotion/styled";

import {
  Avatar as MuiAvatar,

  Breadcrumbs as MuiBreadcrumbs,
  Divider as MuiDivider,
  TableContainer,
  TableBody,
  Table,
  TableCell,
  Paper as MuiPaper,
  TableRow,
  TextField,
} from "@mui/material";
import { spacing } from "@mui/system";
import useAuth from "../../../../hooks/useAuth";

import Grid from '@mui/material/Unstable_Grid2'; // Grid version 2

const FontFamily='-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"';



const Paper = styled(MuiPaper)(spacing);



function SignatureItensComponent({signatureM,reload}) {
  
    return (

      <React.Fragment>
      
      <Grid  container justifyContent="center">

        <Grid sm={12} xl={4} mt={3} sx={{borderRight: '4px solid #eaeaea', marginRight:2}}>
     
        <TableContainer component={Paper} >
           
           <Table  size="medium" aria-label="a dense table">
             <TableBody>
            
                 <TableRow
                   sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                 >   
                 <TableCell component="th" scope="row" sx={{fontSize:14, fontFamily:FontFamily, textAlign:"center"}}>
                 <strong>Descrição</strong> 
                </TableCell>
                <TableCell align="left" sx={{fontSize:14, fontFamily:FontFamily}}>
                <strong>Qtd</strong>
                </TableCell>
                <TableCell align="left" sx={{fontSize:14, fontFamily:FontFamily}}>
                <strong>Valor</strong>
                </TableCell>
                <TableCell align="left" sx={{fontSize:14, fontFamily:FontFamily}}>
                <strong>SubTotal</strong>
                </TableCell>
              </TableRow>

              <TableRow
                   sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                 >   
                 <TableCell component="th" scope="row" sx={{fontSize:13, fontFamily:FontFamily, textAlign:"center"}}>
                 <TextField
                  fullWidth
                  id="referenceField"
                  label="Descrição"
                />
                </TableCell>
                <TableCell align="left" sx={{fontSize:13, fontFamily:FontFamily}}>
                Qtd
                </TableCell>
                <TableCell align="left" sx={{fontSize:13, fontFamily:FontFamily}}>
                Valor
                </TableCell>
                <TableCell align="left" sx={{fontSize:13, fontFamily:FontFamily}}>
                Valor
                </TableCell>
              </TableRow>

            </TableBody>  
          </Table>   
        </TableContainer>   
      </Grid>
  </Grid>   

      </React.Fragment>

  );
}

export default SignatureItensComponent;
